import { render, staticRenderFns } from "./ban-hang-doanh-nghiep.vue?vue&type=template&id=4e258145&"
import script from "./ban-hang-doanh-nghiep.vue?vue&type=script&lang=js&"
export * from "./ban-hang-doanh-nghiep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports